import React from "react";

function UnlockThePotential() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>
              Unlock the Potential of Blockchain with Our Expert Solutions
            </h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Xeer Technology specializes in comprehensive Crypto Coin and
                  Token Development Services designed to help businesses and
                  entrepreneurs harness the power of blockchain technology.
                  Whether you need a unique cryptocurrency or a specialized
                  token, our team of experienced developers is here to guide you
                  through the entire process.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default UnlockThePotential;
